import React, { useState, useEffect } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from "axios";
import { Link, useParams } from 'react-router-dom';
import decryptedUserId from '../Utils/UserID';

const WeeklyOff = () => {
  const { empolyeeid } = useParams();
  const [rows, setRows] = useState([]);

const formatDate = (inputDate) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2);
  const day = (`0${date.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`; // ✅ Browser-friendly format
};


  useEffect(() => {
    if (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") {
      fetchWeeklyOffData();
    }
  }, [empolyeeid]);

  const fetchWeeklyOffData = async () => {
    if (!empolyeeid || empolyeeid === ":empolyeeid" || empolyeeid === "undefined") {
      setRows([]);
      return;
    }
    try {
      const res = await axios.post(`${BASE_URL}/get_employee_weekly_off`, { empolyeeid });
      const data = res.data;
      if (data && data.length > 0) {
        const formatted = data.map((item) => ({
          Id: item.Id || undefined,
          WeekDay: item.WeekDay || "",
          DateFrom: formatDate(item.DateFrom),
          ToDate: formatDate(item.ToDate),
        }));
        setRows(formatted);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error("Error fetching weekly off data:", err);
      setRows([]);
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
  };

  const addNewRow = () => {
    setRows([...rows, { WeekDay: '', DateFrom: '', ToDate: '' }]);
  };

  const handleCancelRow = (indexToRemove) => {
    const updatedRows = rows.filter((_, index) => index !== indexToRemove);
    setRows(updatedRows);
  };
function formatDateToYYYYMMDD(dateString) {
     const date = new Date(dateString);
     if (isNaN(date)) return ""; // handle invalid date
     const year = date.getFullYear();
     const month = (`0${date.getMonth() + 1}`).slice(-2); // pad with 0
     const day = (`0${date.getDate()}`).slice(-2);
     return `${year}-${month}-${day}`;
 }
  const handleSave = async (e) => {
  e.preventDefault();

  if (!empolyeeid || empolyeeid === ":empolyeeid" || empolyeeid === "undefined") {
    alert("Please select or save employee first.");
    return;
  }

  // Basic validation: ensure all rows have required fields
  for (let row of rows) {
    if (!row.WeekDay || !row.DateFrom || !row.ToDate) {
      alert("Please fill in all required fields.");
      return;
    }
  }

  // Construct payload
  const data = {
    empolyeeid: empolyeeid,
    createdBy: decryptedUserId(),
    updatedBy: decryptedUserId(),
    records: rows.map((record) => ({
      Id: record.Id || null,
      WeekDay: record.WeekDay,
      DateFrom: formatDateToYYYYMMDD(record.DateFrom),
      ToDate: formatDateToYYYYMMDD(record.ToDate)
    }))
  };

  try {
    const res = await axios.post(`${BASE_URL}/save_or_update_employee_weekly_offs`, data);

    if (res.data.success) {
      alert("Record(s) saved successfully!");
      fetchWeeklyOffData(); // Refresh list
    } else {
      alert("Failed to save record: " + res.data.message);
    }
  } catch (err) {
    console.error("Error saving record:", err);
    alert("An error occurred while saving.");
  }
};

  const activeEmpId = (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") ? empolyeeid : ":empolyeeid";

  return (
    <div className="container-fluid page-body-wrapper">
      <InnerHeader />
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="d-flex flex-wrap">
            {/* Navigation Tabs */}
            <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${activeEmpId}`}><h4>Personal Information</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/emailcredential/${activeEmpId}`}><h4>Email Credential</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${activeEmpId}`}><h4>Academic Qualification</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/workexperience/${activeEmpId}`}><h4>Work Experience</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/leavestructure/${activeEmpId}`}><h4>Leave Structure</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/salarystructure/${activeEmpId}`}><h4>Salary Structure</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/weeklyoff/${activeEmpId}`}><h4>Weekly Off</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/intimesetting/${activeEmpId}`}><h4>Intime Setting</h4></Link></div>
          </div>

          {/* Weekly Off Card */}
          <div className="col-lg-12 grid-margin stretch-card mt-4">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title titleback">Weekly Off</h2>
                <hr />

                {rows.map((row, index) => (
                  <div key={index} className="border p-3 mb-4 rounded bg-light">
                    <div className="row">
                      <div className="col-md-2">
                        <label>WeekDay</label>
                        <select
                          className="form-control"
                          name="WeekDay"
                          value={row.WeekDay}
                          onChange={(e) => handleInputChange(e, index)}
                        >
                          <option value="">Select Day</option>
                          <option value="Sunday">Sunday</option>
                          <option value="Monday">Monday</option>
                          <option value="Tuesday">Tuesday</option>
                          <option value="Wednesday">Wednesday</option>
                          <option value="Thursday">Thursday</option>
                          <option value="Friday">Friday</option>
                          <option value="Saturday">Saturday</option>
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label>Date From</label>
                        <input
                          type="date"
                          className="form-control"
                          name="DateFrom"
                          value={row.DateFrom}
                          onChange={(e) => handleInputChange(e, index)}
                        />
                      </div>

                      <div className="col-md-2">
                        <label>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="ToDate"
                          value={row.ToDate}
                          onChange={(e) => handleInputChange(e, index)}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-3 d-flex align-items-end">
                        <button className="btn btn-danger btn-sm" onClick={() => handleCancelRow(index)}>Remove</button>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="mt-4">
                  <button type="button" className="btn btn-success" onClick={addNewRow}>Add Row</button>
                  <button type="submit" className="btn btn-primary mx-2" onClick={handleSave}>Save</button>
                  <button type="button" className="btn btn-light" onClick={() => window.location.reload()}>Close</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeeklyOff;
